import useSound from "use-sound";
import {useEffect} from "react";
import {playAudioInstructions} from "../../../AppSettings";

const Sound = ({
                 id,
                 soundPath,
                 render
               }) => {
  const [play, { stop }] = useSound(soundPath, {
    interrupt: true
  });

  const isMuted = () => {
    return !playAudioInstructions();
  }

  useEffect(() => {
    if (id && render && !isMuted()) {
      play();
    }

    return () => {
      stop();
    };
  }, [id, play, render, stop]);

  return (
    <></>
  );
};

export default Sound;